var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6263 2.16341V2.03841H6.5013L1.7513 2.03841H1.6263V2.16341L1.6263 14.8301V14.9551H1.7513H11.2513H11.3763V14.8301V6.91341V6.78841H11.2513L7.6888 6.78841C7.10202 6.78841 6.6263 6.31271 6.6263 5.72591V2.16341ZM8.17302 2.40294L7.95963 2.18955V2.49133V5.33008V5.45508H8.08463L10.9234 5.45508H11.2252L11.0118 5.24169L8.17302 2.40294ZM7.75673 0.705078C8.09959 0.705078 8.43003 0.825835 8.69118 1.04381L8.78986 1.13416L12.2825 4.6268L12.3694 4.53986L12.2825 4.6268C12.525 4.86926 12.6732 5.18831 12.7038 5.52709L12.7096 5.66074V14.8301C12.7096 15.5981 12.1159 16.2275 11.3625 16.2842L11.249 16.2884H1.7513C0.983316 16.2884 0.353889 15.6947 0.297141 14.9413L0.292969 14.8278L0.292969 2.16341C0.292969 1.39543 0.886689 0.765999 1.64008 0.70925L1.7536 0.705078L7.75673 0.705078Z",
    fill: "#545554",
    stroke: "#F6F6F6",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileShape);
export default __webpack_public_path__ + "static/media/fileShape.3e675d82afd7e7db409d3dc22427d2d5.svg";
export { ForwardRef as ReactComponent };